export default "__VITE_ASSET__CpIWgIia__"